// @ts-nocheck

import * as React from 'react';
import { Link } from '@cloudscape-design/components';

export function getMatchesCountText(count) {
  return count === 1 ? `1 match` : `${count} matches`;
}

// function formatDate(date) {
//   const dateFormatter = new Intl.DateTimeFormat('en-AU', { dateStyle: 'long' });
//   const timeFormatter = new Intl.DateTimeFormat('en-AU', { timeStyle: 'short', hour12: false });
//   return `${dateFormatter.format(date)}, ${timeFormatter.format(date)}`;
// }

function createLabelFunction(columnName) {
  return ({ sorted, descending }) => {
    const sortState = sorted ? `sorted ${descending ? 'descending' : 'ascending'}` : 'not sorted';
    return `${columnName}, ${sortState}.`;
  };
}


const convertSecondstoLaptime = (timeString:string) => {
  const totalSeconds = timeString.slice(0, timeString.length -4)
  const milliseconds = timeString.slice(-4)
  const minutes = Math.floor(totalSeconds /60 )
  const seconds = totalSeconds - (minutes * 60)

  return `${minutes}:${seconds}.${milliseconds}`
}

export const columnDefinitions = [
    {
      id: "sessionName",
      header: "Session Name",
      cell: item => item.sessionName ? item.sessionName : "-",
      sortingField: "sessionName",
      ariaLabel: createLabelFunction('Session Name'),
    },{
      id: "sessionType",
      header: "Session Type",
      cell: item => item.sessionType ? item.sessionType : "-",
      sortingField: "sessionType",
      ariaLabel: createLabelFunction('Session Type'),
    },{
      id: "position",
      header: "Position",
      cell: item => item.position !== undefined ? item.position + 1 : "-",
      sortingField: "position",
      ariaLabel: createLabelFunction('Position'),
    },{
      id: "userName",
      header: "Driver Name",
      cell: item => item.userName ? item.userName : "-",
      sortingField: "userName",
      ariaLabel: createLabelFunction('Driver Name'),
    },{
      id: "userId",
      header: "User ID",
      cell: item => item.userId ? item.userId : "-",
      sortingField: "userId",
      ariaLabel: createLabelFunction('User ID'),
    },{
      id: "iRating",
      header: "iRating",
      cell: item => item.iRating ? item.iRating : "-",
      sortingField: "iRating",
      ariaLabel: createLabelFunction('iRating'),
    },{
      id: "carNumber",
      header: "Car #",
      cell: item => item.carNumber ? item.carNumber : "-",
      sortingField: "carNumber",
      ariaLabel: createLabelFunction('Car #'),
    },{
      id: "fastestTime",
      header: "Lap Time",
      cell: item => item.fastestTime? convertSecondstoLaptime(item.fastestTime.toString()) : "-",
      sortingField: "fastestTime",
      ariaLabel: createLabelFunction('Lap Time'),
    },{
      id: "fastestLap",
      header: "Fastest Lap",
      cell: item => item.fastestLap? item.fastestLap : "-",
      sortingField: "fastestLap",
      ariaLabel: createLabelFunction('Fastest Lap'),
    },{
      id: "lapsComplete",
      header: "Laps Complete",
      cell: item => item.lapsComplete ? item.coulapsCompletentry : "-",
      sortingField: "lapsComplete",
      ariaLabel: createLabelFunction('Laps Complete'),
    },{
      id: "incidents",
      header: "Incidents",
      cell: item => item.incidents ? item.incidents : "-",
      sortingField: "incidents",
      ariaLabel: createLabelFunction('Incidents'),
    },{
      id: "irSessionId",
      header: "Session ID",
      cell: item => item.irSessionId ? item.irSessionId : "-",
      sortingField: "irSessionId",
      ariaLabel: createLabelFunction('Session ID'),
    },{
      id: "irSubSessionId",
      header: "Sub Session ID",
      cell: item => item.irSubSessionId ? item.irSubSessionId : "-",
      sortingField: "irSubSessionId",
      ariaLabel: createLabelFunction('Sub Session ID'),
    },{
      id: "reasonOutStr",
      header: "Reason Out",
      cell: item => item.reasonOutStr ? item.reasonOutStr : "-",
      sortingField: "reasonOutStr",
      ariaLabel: createLabelFunction('Reason Out'),
    },
];

export const paginationLabels = {
  nextPageLabel: 'Next page',
  pageLabel: pageNumber => `Go to page ${pageNumber}`,
  previousPageLabel: 'Previous page',
};

const pageSizePreference = {
  title: 'Select page size',
  options: [
    { value: 10, label: '10 resources' },
    { value: 20, label: '20 resources' },
    { value: 50, label: '50 resources' },
    { value: 100, label: '100 resources' },
  ],
};

const visibleContentPreference = {
  title: 'Select visible content',
  options: [
    {
      label: 'Main properties',
      options: columnDefinitions.map(({ id, header }) => ({ id, label: header, editable: id !== 'id' })),
    },
  ],
};
export const collectionPreferencesProps = {
  pageSizePreference,
  visibleContentPreference,
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  title: 'Preferences',
};